/**
 * PaginatorLimiter — page-size selector for `Paginator` (renamed + rethemed
 * from the retired legacy paginator limiter). Renders the shared page-size
 * options as a themed `dp-select-wrapper` dropdown and reports the chosen
 * limit via `onChangeLimit`.
 */
import {PaginationInfo} from "@devour/client";
import {ISelectOption} from "../inputs/SelectOptionsFactory";
import {FC} from "react";
import {FiChevronDown} from "react-icons/fi";

interface IProps extends PaginationInfo {
    onChangeLimit: (newLimit: number) => void;
}

/** Shared page-size options, also consumed by callers to seed a default limit. */
export const paginationLimiterOptions: Array<ISelectOption<number>> = [
    {
        value: 10,
        label: "10",
    },
    {
        value: 12,
        label: "12",
    },
    {
        value: 24,
        label: "24",
    },
    {
        value: 36,
        label: "36",
    },
    {
        value: 48,
        label: "48",
    },
];

const PaginatorLimiter: FC<IProps> = (props) => {
    function onChangeHelper(e): void {
        props.onChangeLimit(parseInt(e?.target?.value));
    }

    return (
        <div className="dp-paginator_limiter-container">
            <div className="dp-paginator_limiter-container_limiter">
                <label>
                    {`${props.lowerRange} - ${props.upperRange} out of ${props.total}`}
                </label>

                <div className="dp-select-wrapper">

                    <select
                        value={props.limit}
                        onChange={onChangeHelper}
                    >
                        {paginationLimiterOptions?.map((option, i: number) => {
                            return (
                                <option
                                    key={`limiter-option_${i}`}
                                    value={option.value}
                                >
                                    {option.label}
                                </option>
                            );
                        })}
                    </select>
                    <div className="dp-select-wrapper_icon-container">
                        <FiChevronDown/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaginatorLimiter;
